import 'ol/ol.css';
import Point from 'ol/geom/Point';
import VectorSource from 'ol/source/Vector.js';
import Feature from 'ol/Feature';
import DrawFunctions from '../helpers/DrawFunctions';
import proj4 from 'proj4';
import WebGLPointsLayer from 'ol/layer/WebGLPoints';
import MapElement from './MapElement';

export default class MapDiagnosticsDots extends MapElement {
    constructor(map, id, mapElementSettings, parent) {
        super(map, id, mapElementSettings, parent)
    }

    drawLayer(data, projection) {
        var sourceproj = new proj4.Proj(projection);
        var destproj = new proj4.Proj(this.mapModel.projection);

        var features = [];

        var machineLocation = proj4.transform(sourceproj, destproj, [data.CorGPSX, data.CorGPSY]);

        if (data.lidarlog) {
            let logsize = data.lidarlog.data.length;
            for (let i = 0; i < logsize - 1; i++) { // last log is empty
                let coordinates = data.lidarlog.data[i];

                coordinates = DrawFunctions.RotateCoordinates(coordinates.x, coordinates.y, data.Heading2Atan2 - (0.5 * Math.PI));

                coordinates = { x: coordinates.x + machineLocation.x, y: coordinates.y + machineLocation.y };

                let feature = new Feature(new Point([coordinates.x, coordinates.y]));

                features.push(feature);
            }

        }


        const lidarSource = new VectorSource({
            features: features
        });

        this.layer = new WebGLPointsLayer({
            source: lidarSource,
            style: {
                symbol: {
                    symbolType: 'circle',
                    size: 5,
                    color: '#0000FF',
                    opacity: 0.9
                }
            },
        });

        if (this.parent && this.parent.layer) {
            this.parent.layer.getLayers().push(this.layer);
        }

        if (!this.mapElementSettings.defaultOn) {
            this.hide();
        }
    }
}